import type { AktenTabId } from "../../views/KundenAkte.js";
import type { PanelBezug, SprungBezug } from "./objektBezug.js";

/** Name und Präposition je Art: „Zum Liefervertrag …“, „Zur Eingangsrechnung …“. */
const ART: Readonly<Record<PanelBezug["art"], { name: string; zu: "Zum" | "Zur" }>> = {
  ticket: { name: "Ticket", zu: "Zum" },
  meilenstein: { name: "Meilenstein", zu: "Zum" },
  liefervertrag: { name: "Liefervertrag", zu: "Zum" },
  eingangsrechnung: { name: "Eingangsrechnung", zu: "Zur" },
  angebot: { name: "Angebot", zu: "Zum" },
  auftrag: { name: "Auftrag", zu: "Zum" },
  rechnung: { name: "Rechnung", zu: "Zur" },
  konto: { name: "Konto", zu: "Zum" },
  planposition: { name: "Planposition", zu: "Zur" },
};

/** Der Sprung auf einen Reiter ohne Vorgang, wo er mehr sagt als „Zur Akte“ (P12: Lieferant ohne Objekt). */
const REITER_OHNE_VORGANG: Readonly<Partial<Record<AktenTabId, (name: string) => string>>> = {
  eingangsrechnungen: (name) => `Zu den Eingangsrechnungen von ${name}`,
};

const satz = (...teile: (string | undefined)[]): string => teile.filter((t) => t !== undefined && t !== "").join(" ");

/**
 * Die Texte der Objektverweise und Objektpanels (Spec F1, P12) — Sofort-Popup und zugänglicher Name der Knöpfe von
 * `me-verweis` nach dem Muster von me-design („Zum Auftrag ME-AU-2026-0002“).
 */
export const OBJEKT_TEXT = {
  /** Panelknopf: „‹Art› ‹Name› bearbeiten“ (108 A, F15). */
  panel: (b: PanelBezug): string => satz(ART[b.art].name, b.label, "bearbeiten"),
  /** Sprungknopf: „Zum/Zur ‹Art› ‹Name›“, Kunde „Zur Akte ‹Name›“. */
  sprung: (b: SprungBezug): string => {
    if (b.art !== "akte") return satz(ART[b.art].zu, ART[b.art].name, b.label);
    const reiter = b.vorgangId === undefined && b.folderId === undefined ? REITER_OHNE_VORGANG[b.reiter] : undefined;
    return reiter === undefined ? satz("Zur Akte", b.label) : reiter(b.label);
  },
  /** Der Auslöser des Menüs „weitere Aktionen“ (Anatomie Teil 15). */
  menue: "⋯",
  laedt: "Lädt …",
} as const;
